var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocument(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 28 28",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#6a4ff5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.88 12.255h-3.25a4.843 4.843 0 0 1-4.837-4.837v-3.25c0-.619-.506-1.125-1.125-1.125H9.9c-3.465 0-6.265 2.25-6.265 6.265v9.965c0 4.015 2.8 6.265 6.265 6.265h8.84c3.464 0 6.265-2.25 6.265-6.265v-5.894c0-.618-.506-1.124-1.125-1.124z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.594 3.28c-.461-.461-1.26-.147-1.26.495V7.7c0 1.642 1.395 3.003 3.093 3.003 1.069.011 2.553.011 3.824.011.641 0 .979-.753.529-1.203-1.62-1.631-4.522-4.567-6.186-6.231z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocument);
export default __webpack_public_path__ + "static/media/document.5e511535d2283dc05e421e5b0c01ee87.svg";
export { ForwardRef as ReactComponent };